interface SectionPreviewTagProps {
  index: number;
  total: number;
  title: string;
}

export default function SectionPreviewTag({
  index,
  total,
  title,
}: SectionPreviewTagProps) {
  return (
    <div className=" bg-[#885ABB] inline-block text-white text-xs font-semibold px-3 py-1 rounded-sm">
      Section {index + 1} of {total}
    </div>
  );
}
